<template>
  <div>
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <loadingcomp v-bind:mesaj="''" v-model="loadingvmodel"></loadingcomp>

    <v-form>
      <v-card color="grey lighten-5">
        <v-layout row wrap>
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title class="baslikfont"> {{ $t('Corporate-Parameters') }} </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn hidden="xs" flat @click="Kaydet()"> {{$t("save_button")}}
                <v-icon right dark>add_box</v-icon>
              </v-btn>
            </v-toolbar>
          </v-flex>
          <v-tabs style="width:100%; height:100%" dark="" v-model="active" color="blue darken-3" slot="extension"
            slider->
            <v-tabs-slider></v-tabs-slider>
            <v-tab href='#0'>
              {{$t("tab_general")}}
            </v-tab>
            <v-tab-item :id="'0'" style="width:100%; height:100%;">
              <v-layout row="" wrap="">
                <v-flex pa-1 xs12 sm12 md4>
                  <v-card>
                    <v-card color="grey lighten-5" flat="">
                      <v-card-actions>
                        <v-layout justify-space-between column>


                          <v-text-field hide-details="" v-model="SirketParametre.Il" label="İl"></v-text-field>
                          <v-text-field :label="$t('District')" hide-details="" v-model="SirketParametre.Ilce"></v-text-field>
                          <v-text-field mask="NNNNNNNNNNNNNNN" hide-details="" v-model="SirketParametre.Tel"
                            :label="$t('Phonenumber_label')">
                          </v-text-field>
                          <v-text-field mask="NNNNNNNNNNNNNNN" hide-details="" v-model="SirketParametre.Fax"
                            label="Fax">
                          </v-text-field>
                          <v-text-field hide-details="" v-model="SirketParametre.Email" :label="$t('Company-E-mail-Address')">
                          </v-text-field>
                          <v-textarea v-model="SirketParametre.Adres" hide-details :label="$t('Address_label')"></v-textarea>
                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>


                <v-flex pa-1 xs12 sm12 md4>
                  <v-card>
                    <v-card color="grey lighten-5" flat="">
                      <v-card-actions>

                        <v-layout justify-space-between column>

                          <v-text-field hide-details="" v-model="SirketParametre.VergiDairesi" :label="$t('Taxcenter_label')">
                          </v-text-field>
                          <v-text-field hide-details="" v-model="SirketParametre.VergiNo" :label="$t('Taxnumber_label')">
                          </v-text-field>
                          <v-text-field hide-details="" type="Number" v-model="SirketParametre.FaturaSatirAdedi"
                            :label="$t('Number-of-Rows-in-Invoice')" value=""></v-text-field>
                          <v-text-field v-if="PB=='TRY'" hide-details="" label="Ticaret Sicil No"
                            v-model="SirketParametre.TicaretSicilNo" value=""></v-text-field>

                          <parainput :simge="getparabirimi()" :etiket="$t('Cash-Turnover')" v-model="SirketParametre.KasaDevir"
                            :autocomplete="'autocomplete'"></parainput>

                          <v-text-field v-if="PB=='TRY'" hide-details="" v-model="SirketParametre.MersisNo" :label="$t('Central-Registration-No')">
                          </v-text-field>
                          <v-text-field hide-details="" v-model="SirketParametre.WebAdres" :label="$t('Company-Web-Address')">
                          </v-text-field>
                        </v-layout>

                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>

                <v-flex pa-1 xs12 sm12 md4>
                  <v-card>
                    <v-card color="grey lighten-5" flat="">
                      <v-card-actions>
                        <v-layout justify-space-between column>

                          <v-text-field v-if="PB=='TRY'" hide-details="" v-model="SirketParametre.SmsKod" :label="'SMS' + $t('Customer-Code')">
                          </v-text-field>
                          <v-text-field  v-if="PB=='TRY'" hide-details="" v-model="SirketParametre.SmsSifre" :label="$t('SMS-Password')">
                          </v-text-field>
                          <v-text-field hide-details="" v-model="SirketParametre.SerbestMail"
                            :label="$t('Free-Invoice-Mail-Design')">
                          </v-text-field>
                          <v-select v-if="PB=='TRY'" :items="doviztipi" clearable item-text="DovizAdi" item-value="DovizKod"
                            v-model="SirketParametre.DefaultCurrency" :label="$t('Default-Currency')"></v-select>
                          <v-select v-if="PB=='TRY'" :items="efaturatipi" hide-details="" item-text="text" item-value="value"
                            v-model="SirketParametre.VarsayilanEfaturaTip" :label="$t('E-invoicetype')" clearable="">
                          </v-select>
                          <v-select v-if="PB=='TRY'" :items="kurparametresi" clearable hide-details=""
                            v-model="SirketParametre.OpsiyonBilgileri.KurParametre" item-text="text" item-value="value"
                            :label="$t('Currency-Parameter')" autocomplete></v-select>
                           <v-select v-if="PB=='TRY'" :items="tevkifatparametresi" clearable hide-details="" 
                            v-model="SirketParametre.BiletTevkifatIstisnaKodu" item-text="Title" item-value="Ad"
                            :label="$t('Withholding-Exception-Code')" autocomplete></v-select>
                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-tab-item>

            <v-tab href='#1' ripple>
              {{this.$t('Options')}}
            </v-tab>
            <v-tab-item :id="'1'">
              <v-container fluid="">
                <v-layout row="" wrap="">



                  <v-flex xs12 sm6 md4>
                    <v-switch :label="$t('Using-Invoice-Closing')" v-model="SirketParametre.OpsiyonBilgileri.FaturaKapama"
                      value="1"></v-switch>
                  </v-flex>



                  <v-flex xs12 sm6 md4 v-if="PB=='TRY'">
                    <v-switch v-if="PB=='TRY'" :label="$t('Using-E-archive')" v-model="SirketParametre.OpsiyonBilgileri.EArsiv" value="1">
                    </v-switch>
                  </v-flex>

                  <v-flex xs12 sm6 md4 v-if="PB=='TRY'">
                    <v-switch v-if="PB=='TRY'" :label="$t('Standard-E-invoice-System')"
                      v-model="SirketParametre.OpsiyonBilgileri.EFaturaKullaniyor" value="1"></v-switch>
                  </v-flex>

                  <v-flex xs12 sm6 md4 v-if="PB=='TRY'">
                    <v-switch v-if="PB=='TRY'" :label="$t('Special-E-invoice-System')"
                      v-model="SirketParametre.OpsiyonBilgileri.OzelFaturaKullaniyor" value="1"></v-switch>
                  </v-flex>


                  <v-flex xs12 sm6 md4 v-if="PB=='TRY'">
                    <v-switch v-if="PB=='TRY'" :label="$t('Using-E-ledger')" v-model="SirketParametre.OpsiyonBilgileri.EDefter" value="1">
                    </v-switch>
                  </v-flex>

                  <v-flex xs12 sm6 md4>
                    <v-switch :label="$t('Print-Discount')" v-model="SirketParametre.OpsiyonBilgileri.IskontoBas" value="1">
                    </v-switch>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-switch :label="$t('Show-Risk-on-Customer')" v-model="SirketParametre.OpsiyonBilgileri.Risk" value="1" c>
                    </v-switch>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-switch :label="$t('Selling-Currency-VAT-Amount')"
                      v-model="SirketParametre.OpsiyonBilgileri.KdvsizSatis" value="1"></v-switch>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-switch :label="$t('Buying-Currency-on-VAT-Excluded-Amount')" v-model="SirketParametre.OpsiyonBilgileri.KdvsizAlis"
                      value="1"></v-switch>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-switch :label="$t('Synchronize-Sales-Number-with-Ticket')"
                      v-model="SirketParametre.OpsiyonBilgileri.FaturaNoSenkronize" value="1"></v-switch>
                  </v-flex>

                  <v-flex xs12 sm6 md4 v-if="PB=='TRY'">
                    <v-switch v-if="PB=='TRY'" :label="$t('Generate-E-invoice-No-Automatically')"
                      v-model="SirketParametre.OpsiyonBilgileri.OtomatikEFaturaNo" value="1"></v-switch>
                  </v-flex>
                  <v-flex xs12 sm6 md4 v-if="PB=='TRY'">
                    <v-switch v-if="PB=='TRY'" :label="$t('E-invoice-with-Serial-No-with-Zero')"
                      v-model="SirketParametre.OpsiyonBilgileri.EFaturaSifirSerili"></v-switch>
                  </v-flex>


                  <v-flex xs12 sm6 md4 v-if="PB=='TRY'">
                    <v-switch v-if="PB=='TRY'" :label="$t('Print-Details-E-invoice-E-archive')" value="1" c></v-switch>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-switch :label="$t('Take-2nd-Row-Invoice-Address2')" value="1"
                      v-model="SirketParametre.Adres2"></v-switch>
                  </v-flex>
                  <v-flex xs12 sm6 md4 v-if="PB=='TRY'">
                    <v-switch v-if="PB=='TRY'" :label="$t('Cancel-Offset-when-Cancelling-Integration')"
                      v-model="SirketParametre.OpsiyonBilgileri.EntMahsup" value="1" ></v-switch>
                  </v-flex>
                    <v-flex xs12 sm6 md4 v-if="PB=='TRY'">
                    <v-switch v-if="PB=='TRY'" label="Cari Aramayı Uyarı alanından da yap"
                      v-model="SirketParametre.UyariAra"  ></v-switch>
                  </v-flex>

                  <v-flex xs12 sm6 md4 v-if="PB=='TRY'">
                    <v-switch v-if="PB=='TRY'" label='Serbest e-Faturada "VADE TARIHI" basma'
                      v-model="SirketParametre.OpsiyonBilgileri.SerbestVadeTarihibasma"></v-switch>
                  </v-flex>
                  <v-flex xs12 sm6 md4 v-if="PB=='TRY'">
                    <v-switch v-if="PB=='TRY'" label='Serbest e-Faturada "MERSIS NO" basma'
                      v-model="SirketParametre.OpsiyonBilgileri.SerbestMersisNobasma"></v-switch>
                  </v-flex>



                </v-layout>
              </v-container>
            </v-tab-item>


            <v-tab href='#2' ripple v-if="PB=='TRY'">
              {{$t('Cheque-and-Note')}}
            </v-tab>
            <v-tab-item :id="'2'" style="width:100%; height:100%;">
              <v-flex pa-1 xs12 sm12 md4>
                <v-card>
                  <v-card color="grey lighten-5" flat="">
                    <v-card-actions>
                      <v-layout row="" wrap="">

                        <v-flex xs12 sm12 md12>
                          <v-layout justify-space-between column>
                            <v-text-field hide-details="" v-model="SirketParametre.CekSenetBilgileri.CekAlindiBno"
                              :label="$t('Cheques-Received-Accounting-No')">
                            </v-text-field>
                            <v-text-field hide-details="" v-model="SirketParametre.CekSenetBilgileri.SenetAlindiBNo"
                              :label="$t('Notes-Received-Accounting-No')">
                            </v-text-field>
                            <v-text-field hide-details="" v-model="SirketParametre.CekSenetBilgileri.CekTevdiBno"
                              :label="$t('Company-Cheque-Given-Accounting-No')">
                            </v-text-field>
                            <v-text-field hide-details="" v-model="SirketParametre.CekSenetBilgileri.SenetVHesap"
                              :label="$t('Bill-Account-No-For-Relevant-Company')">
                            </v-text-field>
                          </v-layout>
                        </v-flex>


                      </v-layout>
                    </v-card-actions>
                  </v-card>
                </v-card>
              </v-flex>
            </v-tab-item>

            <v-tab href='#3' ripple v-if="PB=='TRY'">
              Muhasebe
            </v-tab>
            <v-tab-item :id="'3'">
              <v-layout row wrap>
                <v-flex pa-1 xs12 sm6 md6>
                  <v-card>
                    <v-card color="grey lighten-5" flat="">
                      <v-card-actions>
                        <v-flex xs12 sm12 md12>
                          <v-layout justify-space-between column>

                            <v-card flat="" color="#9E9E9E">
                              <v-card-title>
                                <span class="subheading white--text font-weight-medium "> {{$t('Definitions-v2')}}</span>
                              </v-card-title>
                            </v-card>

                            <v-text-field v-model="SirketParametre.MuhasebeBilgileri.AlisKHesap" hide-details=""
                              :label="$t('Discount-Received')">
                            </v-text-field>
                            <v-text-field v-model="SirketParametre.MuhasebeBilgileri.VerisVHesap" hide-details=""
                              :label="$t('Discount-Given')">
                            </v-text-field>
                            <v-text-field v-model="SirketParametre.MuhasebeBilgileri.MuhasebeSirket" hide-details=""
                              :label="$t('Accounting-Company')">
                            </v-text-field>
                            <v-text-field v-model="SirketParametre.MuhasebeBilgileri.KasaHesap" hide-details=""
                              :label="$t('Cash-Accounting-No')">
                            </v-text-field>
                            <v-text-field v-model="SirketParametre.MuhasebeBilgileri.SatisFaturaKdvHesap"
                              hide-details="" :label="$t('Sales-Invoice-Account-VAT-Accounting-No')">
                            </v-text-field>
                            <v-text-field v-model="SirketParametre.MuhasebeBilgileri.AlisFaturaKdvHesap" hide-details=""
                              :label="$t('Buying-Invoice-Disc-VAT-Accounting-No')">
                            </v-text-field>
                            <v-text-field v-model="SirketParametre.MuhasebeBilgileri.SatisIadeKdvHesap" hide-details=""
                              :label="$t('Sales-Refund-VAT-Accounting-Code')">
                            </v-text-field>
                            <v-text-field v-model="SirketParametre.MuhasebeBilgileri.AlisIadeKdvHesap" hide-details=""
                              :label="$t('Buying-Refund-VAT-Accounting-Code')">
                            </v-text-field>
                          </v-layout>
                        </v-flex>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>

                <v-flex pa-1 xs12 sm6 md6>
                  <v-card>
                    <v-card color="grey lighten-5" flat="">
                      <v-card-actions>
                        <v-layout justify-space-between column>

                          <v-card flat="" color="#9E9E9E">
                            <v-card-title>
                              <span class="subheading white--text font-weight-medium "> {{$t('Accounting-Breakdown')}}</span>
                            </v-card-title>
                          </v-card>

                          <v-layout>

                            <v-text-field v-model="SirketParametre.MuhasebeBilgileri.GrupKirilim" hide-details=""
                              :label="$t('Group')"></v-text-field>
                            <v-text-field v-model="SirketParametre.MuhasebeBilgileri.MuavinKirilim" hide-details=""
                              :label="$t('Assistant')">
                            </v-text-field>
                          </v-layout>
                          <v-layout>

                            <v-flex xs12 sm12 md12>
                              <!-- :rules="[(v) => !!v || $t('Mandatory-Areas')]" -->
                  <v-select
                        :items="this.credentialsGenel.MuhasebeSirketler"
                       :item-text="item => item.CompanyShortName +' - '+ '(Firma No: ' +  item.CompanyID + ')'"
                        item-value="CompanyID"
                        label="Muhasebe Firması"
                        v-model="SirketParametre.MuhasebeBilgileri.AccountingCompanyID"
                        :clearable="true"
                        placeholder="Muhasebe Firması Seçin.."
                      ></v-select> 
                </v-flex>
</v-layout>
                        </v-layout>


                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>

              </v-layout>
            </v-tab-item>
          </v-tabs>


        </v-layout>
      </v-card>
    </v-form>
    <template>
      <v-card>
        <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
          :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
          {{ text1 }}

          <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
        </v-snackbar>
      </v-card>
    </template>
  </div>
</template>

<script>
  import auth from '../../../api/auth'
  import helpers from "@/components/app/customcomp/helpers.js"
  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"
  import parainput from '../customcomp/parainput'
  import loadingcomp from "@/components/app/customcomp/loadingcomp"

  export default {
    data() {
      return {
        PB:"TRY",
        credentialsGenel: JSON.parse(window.localStorage.getItem("credentials")),
        seciliMuhasebeFirma:null,
        Sayfayetki: {
          Screen: false,
          Update: false,
          Save: false,
          Delete: false,
          Status: false,
          Message: null,
          islem: 0,
        },
        date: null,
        dateFormatted: null,
        menu: false,
        drawer: null,
        baslik: '',
        SirketParametre: {
          
          SirketKodu: null,
          Adres: '',
          Adres2: '',
          VergiDairesi: '',
          VergiNo: '',
          FaturaSatirAdedi: '',
          KasaDevir: '',
          KapatTarihi: '',
          KapatSifre: '',
          SmsSifre: '',
          SmsKod: '',
          Tel: '',
          Fax: '',
          Email: '',
          Ilce: '',
          Il: '',
          PostaKodu: '',
          CoperSirket: '',
          TicaretSicilNo: '',
          WebAdres: '',
          VarsayilanEfaturaTip: '',
          Dil: '',
          DefaultCurrency: '',
          MersisNo: '',
          SerbestMail: '',
          CekSenetBilgileri: {
            CekPHesap: '',
            CekPKebir: '',
            CekPGrup: '',
            CekPMuavin: '',
            SenetPHesap: '',
            SenetPKebir: '',
            SenetPGrup: '',
            SenetPMuavin: '',
            CekAlindiBno: '',
            CekTevdiBno: '',
            CekNo: '',
            SenetAlindiBNo: '',
            SenetTevdiBNo: '',
            SenetNo: '',
            CekVHesap: '',
            CekVKebir: '',
            CekVGrup: '',
            CekVMuavin: '',
            SenetVHesap: '',
            SenetVKebir: '',
            SenetVGrup: '',
            SenetVMuavin: '',
          },
          MuhasebeBilgileri: {
            AccountingCompanyID:null,
            Muh5aEnt: '',
            GrupKirilim: '',
            MuavinKirilim: '',
            MuhasebeSirket: '',
            KasaHesap: '',
            KasaKebir: '',
            KasaGrup: '',
            KAsaMuavin: '',
            SatisFaturaKdvHesap: '',
            AlisFaturaKdvHesap: '',
            SatisIadeKdvHesap: '',
            AlisIadeKdvHesap: '',
            AlisKHesap: '',
            VerisVHesap: '',
          },
          OpsiyonBilgileri: {
            IskontoBas: '',
            BiletPaket: '',
            Risk: '',
            KdvsizSatis: '',
            KdvsizAlis: '',
            FaturaNoSenkronize: '',
            CoperKullan: '',
            FaturaKapama: '',
            MusteriPersonel: '',
            YolcuCrm: '',
            FaturaMail: '',
            MailOutlook: '',
            Profil: '',
            YeniVersiyonKontrol: '',
            EFaturaKullaniyor: '',
            OzelFaturaKullaniyor: '',
            OtomatikEFaturaNo: '',
            KurParametre: '',
            EntParam: '',
            EntMahsup: '',
            EDefter: '',
            EArsiv: '',
            EFaturaSifirSerili: ''
          },
          BiletTevkifatIstisnaKodu:'',
          UyariAra:false
        },
           SirketParametreYedek: {
          SirketKodu: null,
          Adres: '',
          Adres2: '',
          VergiDairesi: '',
          VergiNo: '',
          FaturaSatirAdedi: '',
          KasaDevir: '',
          KapatTarihi: '',
          KapatSifre: '',
          SmsSifre: '',
          SmsKod: '',
          Tel: '',
          Fax: '',
          Email: '',
          Ilce: '',
          Il: '',
          PostaKodu: '',
          CoperSirket: '',
          TicaretSicilNo: '',
          WebAdres: '',
          VarsayilanEfaturaTip: '',
          Dil: '',
          DefaultCurrency: '',
          MersisNo: '',
          SerbestMail: '',
          CekSenetBilgileri: {
            CekPHesap: '',
            CekPKebir: '',
            CekPGrup: '',
            CekPMuavin: '',
            SenetPHesap: '',
            SenetPKebir: '',
            SenetPGrup: '',
            SenetPMuavin: '',
            CekAlindiBno: '',
            CekTevdiBno: '',
            CekNo: '',
            SenetAlindiBNo: '',
            SenetTevdiBNo: '',
            SenetNo: '',
            CekVHesap: '',
            CekVKebir: '',
            CekVGrup: '',
            CekVMuavin: '',
            SenetVHesap: '',
            SenetVKebir: '',
            SenetVGrup: '',
            SenetVMuavin: '',
          },
          MuhasebeBilgileri: {
            Muh5aEnt: '',
            GrupKirilim: '',
            MuavinKirilim: '',
            MuhasebeSirket: '',
            KasaHesap: '',
            KasaKebir: '',
            KasaGrup: '',
            KAsaMuavin: '',
            SatisFaturaKdvHesap: '',
            AlisFaturaKdvHesap: '',
            SatisIadeKdvHesap: '',
            AlisIadeKdvHesap: '',
            AlisKHesap: '',
            VerisVHesap: '',
          },
          OpsiyonBilgileri: {
            IskontoBas: '',
            BiletPaket: '',
            Risk: '',
            KdvsizSatis: '',
            KdvsizAlis: '',
            FaturaNoSenkronize: '',
            CoperKullan: '',
            FaturaKapama: '',
            MusteriPersonel: '',
            YolcuCrm: '',
            FaturaMail: '',
            MailOutlook: '',
            Profil: '',
            YeniVersiyonKontrol: '',
            EFaturaKullaniyor: '',
            OzelFaturaKullaniyor: '',
            OtomatikEFaturaNo: '',
            KurParametre: '',
            EntParam: '',
            EntMahsup: '',
            EDefter: '',
            EArsiv: '',
            EFaturaSifirSerili: ''
          },
          UyariAra:false
        },
        tevkifatparametresi:[],
        efaturatipi: [{
            text: this.$t('Commercial'),
            value: '0'
          },
          {
            text: this.$t('Basic'),
            value: '1'
          },
          {
            text: this.$t('Export'),
            value: '2'
          },{
             text: this.$t('Public'),
             value: '3'
          }
        ],

        kurparametresi: [{
            text: this.$t('Buying'),
            value: '0'
          },
          {
            text: this.$t('Sales'),
            value: '1'
          },
          {
            text: this.$t('Effective-Buying'),
            value: '2'
          },
          {
            text: this.$t('Effective-Sales'),
            value: '3'
          }

        ],
        doviztipi: [],

        GenelParametre: {
          KdvOran: '',
          HavaYoluHesapGrubu: '',
          SerbestFatura: '',
          SonDekontNo: '',
          DekontTek: '',
          TumSirketler: '',
          XmlPath: '',
          AktarimSure: '',
          XmlPathCari: '',
          XmlPathMaliyetFaturasi: '',
          XmlPathCariHareket: '',
          TumSirketSecili: '',
          FaturaEn: '',
          FaturaBoy: '',
          OzelBoy: '',
          Dot9Sifre: '',
          BolgeAyar: '',
          AnaEkran: '',
          CariAra: '',
          MasrafZorunlu: '',
          MerkezKur: '',
          SerbestFaturaDoviz: '',
          FaturaKapamaAktif: '',
          FaturaKapamaTarih: '',
          CariAramaIc: '',
          DisAkatarimZorunlu: ''
        },
        text1: '',
        active: '',
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        loadingvmodel:false,
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from.path
      })
    },
    beforeMount: beforeMount,
    components: {
      yetkidialog,
      parainput,
      loadingcomp
    },
    mounted() {

      this.sayfayetki = helpers.pageScreenAuth(this.$route.name)

      if (this.sayfayetki.Status == true) {
      var credentials = JSON.parse(window.localStorage.getItem('credentials'));
      this.PB=credentials.ParaBirimi
        var paramsTevkifat = {
          CompanyCode: credentials.SirketKodu,
          Type:304
        }
       this.$http.post(auth.API_URL + 'api/Definitions/GeneralTypeSearch', paramsTevkifat, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.tevkifatparametresi = response.body
        }, (response) => {
        if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
        } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
        }
        })

        this.$http.post(auth.API_URL + 'api/currency/List', {}, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.doviztipi = response.body
        }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      }
        })
        this.loadingvmodel=true

        var params = {
          SirketKodu: credentials.SirketKodu
        }
        this.$http.post(auth.API_URL + 'api/Parameters/CompanyGet', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
                  this.loadingvmodel=false

          this.SirketParametre = response.body
          if (response.body.OpsiyonBilgileri==null){
            this.SirketParametre.OpsiyonBilgileri=this.SirketParametreYedek.OpsiyonBilgileri
          }
             if (response.body.CekSenetBilgileri==null){
            this.SirketParametre.CekSenetBilgileri=this.SirketParametreYedek.CekSenetBilgileri
          }

                if (response.body.MuhasebeBilgileri==null){
            this.SirketParametre.MuhasebeBilgileri=this.SirketParametreYedek.MuhasebeBilgileri
          }



          this.SirketParametre.SirketKodu= credentials.SirketKodu
          this.SirketParametre.VarsayilanEfaturaTip = String(response.body.VarsayilanEfaturaTip)

        if (response.body.OpsiyonBilgileri.KurParametre!=null) {
           this.SirketParametre.OpsiyonBilgileri.KurParametre = String(response.body.OpsiyonBilgileri.KurParametre)
        }

        }, (response) => {
                  this.loadingvmodel=false

          if (response.status === 0) {
            this.text = 'Service Unavailable'
            this.snackbar = true

          } else {
            this.text = 'Service Unavailable'
            this.snackbar = true
          }
        })

      } else {

        this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

          if (sonuc == true) {


            if (this.prevRoute != null) {
              let url = '#' + this.prevRoute

              window.open(url, '_self')
            } else {
              let url = '#/'
              window.open(url, '_self')
            }
          } 

        });

      }
    },

    methods: {
      getparabirimi() {
        return helpers.getparabirimi()
      },
      Kaydet: Kaydet
    },
  }

  function Kaydet() {
    if (this.SirketParametre.MuhasebeBilgileri.AccountingCompanyID=='undefined' || this.SirketParametre.MuhasebeBilgileri.AccountingCompanyID==null)
    {
      this.SirketParametre.MuhasebeBilgileri.AccountingCompanyID=0;
    }
    
            var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    this.SirketParametre.SirketKodu= credentials.SirketKodu

    var params = this.SirketParametre
        this.loadingvmodel=true


    this.$http.post(auth.API_URL + 'api/Parameters/CompanyAdd', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
       this.text1 = this.$t(response.body.ResponseMessage)
      this.snackbar = true
              this.loadingvmodel=false


    }, (response) => {
      if (response.status === 0) {
        this.loadingvmodel=false
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      }
    })
  }



  function beforeMount() {

  }
</script>
<style>
</style>